import type { ReactNode } from "react";
import classnames from "classnames";
import { noop } from "lodash";
import { t } from "@/i18n-js/instance";
import type { ButtonVariant } from "@circle-react-uikit/Button";
import { Button } from "@circle-react-uikit/Button";
import { Portal } from "@circle-react-uikit/Portal";
import "./styles.scss";

export interface ConfirmProps {
  bodyElement?: ReactNode;
  buttonLabel?: string;
  description?: string;
  loading?: boolean;
  maxZIndexEnabled?: boolean;
  onCancel: () => void;
  onClose: () => void;
  onConfirm?: () => void;
  sentiment?: ButtonVariant;
  show?: boolean;
  subtitle: string;
  title: string;
}

export const Confirm = ({
  bodyElement,
  buttonLabel = "",
  description = "",
  loading = false,
  maxZIndexEnabled = false,
  onCancel,
  onClose,
  onConfirm = noop,
  sentiment = "danger",
  show = false,
  subtitle,
  title,
}: ConfirmProps) => {
  if (!show) return null;
  return (
    <Portal className="z-50">
      <div className={classnames("confirm", { "z-2000": maxZIndexEnabled })}>
        <div className="confirm__container">
          <h4 className="confirm__title">{title}</h4>
          {subtitle && <h5 className="confirm__subtitle">{subtitle}</h5>}
          {description && <p className="pt-6 text-center">{description}</p>}
          {bodyElement}
          <div className="confirm__actions">
            <Button variant="secondary" onClick={onCancel || onClose}>
              {t("cancel")}
            </Button>
            <Button disabled={loading} variant={sentiment} onClick={onConfirm}>
              {buttonLabel || t("confirm")}
            </Button>
          </div>
        </div>
      </div>
    </Portal>
  );
};
